export default async function cmsData(query, contentfulAPI) {
  if (!query) return
  const response = await fetch(`${contentfulAPI}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ query }),
  })
  return response
}
